"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletConnectionManager = void 0;
const connect_1 = require("./connect");
const commands_1 = require("./commands");
const storageconstants_1 = require("./storageconstants");
const jwtconstants_1 = require("./jwtconstants");
const constants_1 = require("./constants");
const walletConnectionConstants_1 = require("./walletConnectionConstants");
const connectionSplitPackages_1 = require("./connectionSplitPackages");
const eventemitter3_1 = require("eventemitter3");
const storage_1 = require("./storage");
const utils_1 = require("../utils/utils");
const crypto_1 = require("../crypto/crypto");
const jwt_1 = require("./jwt");
const safejson_1 = require("../utils/safejson");
const log = __importStar(require("../utils/log"));
const log_1 = require("../utils/log");
const utils_2 = require("../utils");
class WalletConnectionManager {
    constructor() {
        this.events = new eventemitter3_1.EventEmitter();
        this.communicateEvents = new eventemitter3_1.EventEmitter();
        this.splitManager = new connectionSplitPackages_1.ConnectionSplitPackages('wallet');
        log.logDebug('connect manager construct');
        // local storage
        this.connectStorage = new storage_1.Storage(storageconstants_1.OKXCONNECTOR_CACHE_KEY);
        this.jwtKeyPair = this.getCachedJWTKeyPair();
        this.saveJWTKeyPair(this.jwtKeyPair);
        // wss connection
        this.connector = new connect_1.OKXWalletConnector(constants_1.OKXCONNECTOR_WS_URL_1);
        this.packageId = Date.now();
        // connection state
        this.sessionCryptoInfoMap = new Map();
        // log.logDebug(`this.connectedWalletPK  constructor   ${this.connectedWalletPK}`)
        this.inLogin = false;
        this.isLogined = false;
    }
    refreshPackageId(offset = 0) {
        let nowDate = Date.now() + offset;
        if (nowDate == this.packageId) {
            this.packageId = nowDate + 1;
        }
        this.packageId = nowDate;
    }
    saveCryptoKeyPair(topicId, keyPair) {
        let cacheInfo = (0, safejson_1.safeJsonStringify)(keyPair);
        // encrypt kp
        this.connectStorage.encryptStoreMsg(cacheInfo, storageconstants_1.OKXCONNECTOR_CRYPTO_KEY + topicId);
    }
    getCachedCryptoKeyPair(topicId) {
        // decrypt kp
        const kp = this.connectStorage.getAndDecrypt(storageconstants_1.OKXCONNECTOR_CRYPTO_KEY + topicId);
        const content = kp;
        if (typeof content == 'string') {
            log.logDebug('get cached crypto key:');
            log.logDebug(content);
            let keyPairInfo = (0, safejson_1.safeJsonParse)(content);
            return keyPairInfo;
        }
        else {
            this.connectStorage.clearCache();
        }
        return null;
    }
    saveJWTKeyPair(keyPair) {
        var strkeyPair = {
            publicKey: (0, utils_1.toHexString)(keyPair.publicKey),
            secretKey: (0, utils_1.toHexString)(keyPair.secretKey)
        };
        log.logDebug('save jwt kp');
        let cacheInfo = (0, safejson_1.safeJsonStringify)(strkeyPair);
        log.logDebug(cacheInfo);
        // encrypt jwt kp
        this.connectStorage.encryptStoreMsg(cacheInfo, storageconstants_1.OKXCONNECTOR_JWT_KEY);
        log.logDebug('after save jwt kp');
    }
    getCachedJWTKeyPair() {
        const kp = this.connectStorage.getAndDecrypt(storageconstants_1.OKXCONNECTOR_JWT_KEY);
        const content = kp;
        if (typeof content == 'string') {
            // TODO: decrypt jwt kp
            log.logDebug('get cached jwt kp:');
            log.logDebug(content);
            let strKeyPairInfo = (0, safejson_1.safeJsonParse)(content);
            log.logDebug('save jwt kp');
            log.logDebug(strKeyPairInfo);
            var keyPair = {
                publicKey: (0, utils_1.hexToByteArray)(strKeyPairInfo.publicKey),
                secretKey: (0, utils_1.hexToByteArray)(strKeyPairInfo.secretKey)
            };
            return keyPair;
        }
        else {
            return (0, jwt_1.generateKeyPair)();
        }
    }
    isTopicPublicKeyExist(topicId) {
        log.logDebug(`isTopicPublicKeyExist  ===> ${topicId}`);
        return this.sessionCryptoInfoMap.get(topicId);
    }
    makeJWT(timestampStr) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield (0, jwt_1.signJWT)(timestampStr, jwtconstants_1.OKXCONNECTOR_JWT_WALLET_SIDE, jwtconstants_1.OKXCONNECTOR_JWT_TTL, // 24h
            this.jwtKeyPair);
        });
    }
    parseInternalMsg(internalMsg) {
        try {
            let internalObj = (0, safejson_1.safeJsonParse)(internalMsg);
            let origin = internalObj['ivur-igbfft-ptjip'];
            if (origin && origin.length > 0) {
                let originContent = (0, utils_2.base64decode)(origin, true);
                return originContent.toString();
            }
        }
        catch (error) {
            log.logError('parse internal msg', error);
        }
    }
    updateClientId(topic, clientId) {
        let sessionInfo = this.sessionCryptoInfoMap.get(topic);
        (0, log_1.logDebug)('updateClientId', sessionInfo, topic, clientId);
        if (sessionInfo && clientId && clientId.length > 0) {
            if (sessionInfo.cid) {
                // check
                let lastCheck = (0, utils_1.getLastSixMd5Hash)(clientId);
                if (sessionInfo.cid == lastCheck) {
                    sessionInfo.dappPublicKey = clientId;
                }
                else {
                    log.logError('cid check failed', sessionInfo, topic, clientId);
                }
            }
            else {
                sessionInfo.dappPublicKey = clientId;
            }
            // 
            this.syncCacheSessionInfo();
        }
        return false;
    }
    parsePackage(topic_1, input_1) {
        return __awaiter(this, arguments, void 0, function* (topic, input, ignoreACK = false) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
            this.events.emit(input.id, input);
            // emit event
            let sessionInfo = this.sessionCryptoInfoMap.get(topic);
            log.logDebug('get sessionInfo for decrypt topic:', topic);
            log.logDebug('get sessionInfo for decrypt:', input.id, topic, sessionInfo, this.sessionCryptoInfoMap);
            let ignoreReceive = false;
            if (sessionInfo && input.params.data) {
                if ((_a = input.params.data) === null || _a === void 0 ? void 0 : _a.message) {
                    // try parse internal message
                    if ((_b = input.params.data) === null || _b === void 0 ? void 0 : _b.isInternalData) {
                        let inner_message = (_c = input.params.data) === null || _c === void 0 ? void 0 : _c.message;
                        let inner_topic = (_d = input.params.data) === null || _d === void 0 ? void 0 : _d.topic;
                        let originContent = this.parseInternalMsg(inner_message);
                        (0, log_1.logDebug)('parse internal origin: ', originContent);
                        if (originContent && originContent.length > 0) {
                            this.communicateEvents.emit("origin", originContent, inner_topic);
                        }
                    }
                    else {
                        // try parse message base64
                        try {
                            let message = (_e = input.params.data) === null || _e === void 0 ? void 0 : _e.message;
                            if (input.method && input.method === commands_1.CONNECT_METHOD_PUSH) {
                                // update topic expire check
                                (0, log_1.logDebug)('checkExpire: update expire when get push');
                                this.updateExpireLimit(topic);
                            }
                            if (message.trimStart().startsWith('{')) {
                                // 判断是否是分包数据
                                let msgPlayloadObject = this.splitManager.tryParseMessageSplitPayload(message);
                                if (msgPlayloadObject) {
                                    (0, log_1.logDebug)('parse split msg object: ', msgPlayloadObject);
                                    // 屏蔽后续的receive逻辑
                                    ignoreReceive = true;
                                    let msgObject = {
                                        topicId: (_g = (_f = input.params) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.topic,
                                        messageId: (_j = (_h = input.params) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.messageId,
                                        messageObject: msgPlayloadObject,
                                        publishedAt: (_l = (_k = input.params) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.publishedAt,
                                    };
                                    let checkResult = yield this.splitManager.onReceivedPackageCheck(msgObject);
                                    if (checkResult.completeMessageIdList) {
                                        checkResult.completeMessageIdList.forEach((msgId) => __awaiter(this, void 0, void 0, function* () {
                                            // 发送批量receive
                                            this.refreshPackageId();
                                            yield this.sendReceive(this.packageId.toString(), msgId, topic);
                                        }));
                                    }
                                    // 抛出finalmessage
                                    if (checkResult.finalMessage) {
                                        let message = sessionInfo.crypto.decryptWallet(checkResult.finalMessage, sessionInfo.dappPublicKey);
                                        (0, log_1.logDebug)('<<< receive msg from split:', topic, message);
                                        this.communicateEvents.emit(topic, message);
                                    }
                                }
                                else {
                                    let messageObj = (0, safejson_1.safeJsonParse)(message);
                                    if (messageObj.method) {
                                        if (messageObj.method == 'session_info') {
                                            let sessionInfoString = messageObj.params.sessionInfo;
                                            let base64Content = (0, utils_2.base64decode)(sessionInfoString, false);
                                            (0, log_1.logDebug)("wallet connection manager requset base64Content:", base64Content);
                                            (0, log_1.logDebug)("base64Content:" + base64Content);
                                            let inner_connection = base64Content.toObject();
                                            this.updateClientId(topic, inner_connection.clientId);
                                        }
                                        (0, log_1.logDebug)('<<< parse raw msg:', topic, messageObj);
                                        this.communicateEvents.emit(topic, message);
                                    }
                                }
                            }
                            else {
                                let message = sessionInfo.crypto.decryptWallet((_m = input.params.data) === null || _m === void 0 ? void 0 : _m.message, sessionInfo.dappPublicKey);
                                (0, log_1.logDebug)('<<< receive msg:', topic, message);
                                this.communicateEvents.emit(topic, message);
                            }
                        }
                        catch (error) {
                            let message = sessionInfo.crypto.decryptWallet((_o = input.params.data) === null || _o === void 0 ? void 0 : _o.message, sessionInfo.dappPublicKey);
                            (0, log_1.logDebug)('<<< receive msg:', topic, message);
                            this.communicateEvents.emit(topic, message);
                        }
                    }
                }
                else {
                }
            }
            // send back ACK
            if (!ignoreACK) {
                yield this.sendACK(input.id, true);
                if (topic && !ignoreReceive) {
                    let inputObj = input;
                    if ((_q = (_p = inputObj.params) === null || _p === void 0 ? void 0 : _p.data) === null || _q === void 0 ? void 0 : _q.messageId) {
                        this.refreshPackageId();
                        yield this.sendReceive(this.packageId.toString(), (_s = (_r = inputObj.params) === null || _r === void 0 ? void 0 : _r.data) === null || _s === void 0 ? void 0 : _s.messageId, topic);
                    }
                }
            }
        });
    }
    recovrySessionInfoFromCache() {
        // get topic ids and keys from session
        // WalletConnectionCryptoCacheMap
        // {[topicId]: {cryptoKeypair: {publicKey:string, secretKey:string}, dappPublicKey:clientId}}
        let jsonStr = this.connectStorage.getAndDecrypt(walletConnectionConstants_1.WalletConnectionManagerTopicInfoCacheKey);
        log.logDebug('get cached sessionInfos:', jsonStr);
        if (jsonStr) {
            let cacheMap = (0, safejson_1.safeJsonParse)(jsonStr);
            for (let topicId in cacheMap) {
                let topicItem = cacheMap[topicId];
                log.logDebug('make topicItem:', topicItem);
                let cryptoItem = {
                    topic: topicId,
                    crypto: new crypto_1.SessionCrypto({
                        publicKey: topicItem.cryptoKeyPair.publicKey,
                        secretKey: topicItem.cryptoKeyPair.secretKey
                    }),
                    dappPublicKey: topicItem.dappPublicKey,
                    cid: topicItem.cid
                };
                this.sessionCryptoInfoMap.set(topicId, cryptoItem);
            }
        }
        log.logDebug('get cached sessionInfos map:', this.sessionCryptoInfoMap);
    }
    syncCacheSessionInfo() {
        let cacheMap = {};
        for (let [topicId, cryptoItem] of this.sessionCryptoInfoMap) {
            log.logDebug('for each Keys', topicId);
            if (cryptoItem) {
                cacheMap[topicId] = {
                    cryptoKeyPair: cryptoItem.crypto.stringifyKeypair(),
                    dappPublicKey: cryptoItem.dappPublicKey,
                    cid: cryptoItem.cid
                };
            }
        }
        let jsonData = (0, safejson_1.safeJsonStringify)(cacheMap);
        log.logDebug('sync cache sessionInfos:', jsonData);
        this.connectStorage.encryptStoreMsg(jsonData, walletConnectionConstants_1.WalletConnectionManagerTopicInfoCacheKey);
    }
    cacheSessionInfo(topic, sessionInfo, sync = true) {
        let dappPublicKey = sessionInfo.dappPublicKey;
        // 1. search dapp public related topic ids
        let duplicatedTopics = [];
        for (let [topicId, cryptoItem] of this.sessionCryptoInfoMap) {
            log.logDebug('for each Keys', topicId);
            if (cryptoItem.dappPublicKey == dappPublicKey) {
                log.logDebug('duplicated dapp public key:', topicId, dappPublicKey);
                duplicatedTopics.push(topicId);
            }
        }
        for (let [topicId, cryptoItem] of this.sessionCryptoInfoMap) {
            if (duplicatedTopics.includes(topicId)) {
                this.sessionCryptoInfoMap.delete(topicId);
            }
        }
        // discard useless topics
        log.logDebug('cleaned connect session cache:', this.sessionCryptoInfoMap);
        // 2. remove previous connected topic ids
        // 3. write in current topic
        this.sessionCryptoInfoMap.set(topic, sessionInfo);
        // TODO: search domain info and then delete 
        log.logDebug('cache sessionInfo:', topic, sessionInfo, this.sessionCryptoInfoMap);
        if (sync) {
            this.syncCacheSessionInfo();
        }
        return duplicatedTopics;
    }
    updateProtocolVersion(topic, protocolVersion) {
        this.splitManager.updateTopicSenderVersion(topic, protocolVersion);
    }
    // add and subscribe topic
    appendTopic(topic, sessionPublicKey, cid) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, log_1.logDebug)('4.1. get append Topic:', topic);
            // 1. check if connected
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                if (!this.isLogined) {
                    var error = new Error();
                    error.message = "connection is not logined";
                    error.name = "append error";
                    // throw error
                    reject(error);
                    return;
                }
                // 2. subscribe topic and session public key
                let cryptoItem = {
                    topic: topic,
                    crypto: new crypto_1.SessionCrypto(),
                    dappPublicKey: sessionPublicKey ? sessionPublicKey : "",
                    cid: cid
                };
                let duplicatedTopics = this.cacheSessionInfo(topic, cryptoItem, false);
                // make sure cache session info before subscribe
                yield this.subscribeTopics(Array.from([topic]));
                this.refreshPackageId();
                log.logDebug(`5. subscribe callback then fetch append message: ${this.packageId}, ${topic}`);
                log.reportLog(`5. subscribe callback then fetch append message`);
                const timeF = new Date().getTime();
                (0, log_1.logDebug)("Append --subscribe callback->", timeF - this.timeLog);
                resolve(duplicatedTopics);
            }));
        });
    }
    confirmAppendingTopics() {
        this.syncCacheSessionInfo();
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeLog = new Date().getTime();
            (0, log_1.logDebug)("[Wallet] ConnectTime---enter->", this.timeLog);
            log.reportLog('wallet connect connect called');
            // 0. get cached topics and infos
            let timestampStr = Date.now().toString();
            var jwtToken = yield this.makeJWT(timestampStr);
            log.logDebug(`generate jwt token: ${jwtToken}`);
            this.connectStorage.saveContent(jwtToken, 'jwt');
            this.recovrySessionInfoFromCache();
            // 1.
            return new Promise((resolve, reject) => {
                // 1. when websocket opened
                this.inLogin = true;
                this.connector.onOpen(() => __awaiter(this, void 0, void 0, function* () {
                    log.logDebug(`1. connector on open`);
                    log.reportLog('1. wallet connect connect on open');
                    const timeOne = new Date().getTime();
                    (0, log_1.logDebug)("ConnectTime---open->", timeOne - this.timeLog);
                    //2. send jwt to login
                    this.events.once(this.packageId.toString(), (rsp) => __awaiter(this, void 0, void 0, function* () {
                        // ack
                        if (rsp && rsp.error) {
                            log.logError('failed when login');
                            yield this.connector.disconnect();
                            var error = new Error();
                            error.message = rsp.error.message;
                            error.name = rsp.error.code.toString();
                            // throw error
                            reject(error);
                        }
                        else {
                            this.isLogined = true;
                            resolve();
                            // 3. subscribe cached topics
                            log.logDebug('3. subscribe cached topics', this.sessionCryptoInfoMap);
                            log.reportLog('3. wallet connect connect subscribe cached topics');
                            if (this.sessionCryptoInfoMap.size > 0) {
                                yield this.subscribeTopics(Array.from(this.sessionCryptoInfoMap.keys()));
                            }
                        }
                    }));
                    log.logDebug(`2. login called`);
                    log.reportLog('2. wallet connect login called');
                    yield this.connector.send(() => __awaiter(this, void 0, void 0, function* () {
                        log.logDebug('CONNECT: reconnect before send');
                        return yield this.connector.connect();
                    }), {
                        id: this.packageId.toString(),
                        jsonrpc: constants_1.CONNECT_JSONRPC_VER,
                        method: commands_1.CONNECT_METHOD_LOGIN,
                        params: {
                            token: jwtToken
                        }
                    });
                }));
                this.connector.connect().catch((err) => {
                    (0, log_1.logDebug)('WalletConnectionManager connect error', err);
                    reject(err);
                });
                // add callback
                this.connector.addPackageParse((event) => {
                    var _a, _b;
                    log.logDebug(`connect: parse package`);
                    log.logDebug(event);
                    if (!("params" in event) || !("data" in event["params"])) {
                        this.parsePackage("", event, true);
                        return;
                    }
                    // ignore receive echo
                    if ((_a = event.params.data) === null || _a === void 0 ? void 0 : _a.topic) {
                        this.parsePackage((_b = event.params.data) === null || _b === void 0 ? void 0 : _b.topic, event, event.method === commands_1.CONNECT_METHOD_RECEIVE);
                    }
                });
                // this.connector.addListener(safeJsonStringify(event), (rawMsg: string)=> {
                //    rawMsg = rawMsg.replace(/'/g, '"')
                //    log.logDebug(`addListener ===> ${rawMsg}`)
                //    if (typeof rawMsg !== 'undefined') {
                //       var msgObj = safeJsonParse(rawMsg)
                //       var msg = msgObj.message
                //       let crypto = 
                //       var result = this.crypto.decrypt(msg, this.connectedWalletPK)
                //       log.logDebug(`addListener ===> ${result}`)
                //       return result
                //    }
                //    return undefined
                // }, ()=>{
                //    // emit success
                // }, ()=>{
                //    // emit fail
                // })
            });
        });
    }
    // 获取对应topic session下的钱包公钥
    // 在返回approve时需要填充到clientId字段中
    getSessionPublicKey(topicId) {
        if (this.isTopicPublicKeyExist(topicId)) {
            let item = this.sessionCryptoInfoMap.get(topicId);
            if (item) {
                return (0, utils_1.toHexString)(item.crypto.keyPair.publicKey);
            }
        }
        return undefined;
    }
    getCurrentCachedTopicIdList() {
        return Array.from(this.sessionCryptoInfoMap.keys());
    }
    sendDisconnect(topic) {
        return __awaiter(this, void 0, void 0, function* () {
            this.refreshPackageId();
            const payload = {
                id: this.packageId.toString(),
                jsonrpc: constants_1.CONNECT_JSONRPC_VER,
                method: commands_1.CONNECT_METHOD_DISCONNECT,
                params: {
                    message: {
                        topic: topic,
                        ttl: constants_1.OKXCONNECTOR_MESSAGE_DISCONNECT_TTL
                    }
                }
            };
            yield this.connector.send(() => __awaiter(this, void 0, void 0, function* () {
                log.logDebug('CONNECT: reconnect before send');
                return yield this.connector.connect();
            }), payload);
        });
    }
    sendRecvDisconnect(topic) {
        return __awaiter(this, void 0, void 0, function* () {
            this.refreshPackageId();
            const payload = {
                id: this.packageId.toString(),
                jsonrpc: constants_1.CONNECT_JSONRPC_VER,
                method: commands_1.CONNECT_METHOD_RECV_DISCONNECT,
                params: {
                    topic: topic,
                }
            };
            yield this.connector.send(() => __awaiter(this, void 0, void 0, function* () {
                log.logDebug('CONNECT: reconnect before send');
                return yield this.connector.connect();
            }), payload);
        });
    }
    disconnect() {
        return __awaiter(this, arguments, void 0, function* (fromRestore = false) {
            yield this.connector.disconnect();
            //clean cached topic
            //如果是恢复连接，就不清理解密public key
            this.connectStorage.clearCache(storageconstants_1.OKXCONNECTOR_TOKEN_CACHE);
            if (!fromRestore) {
                this.connectStorage.clearCache(storageconstants_1.OKXCONNECTOR_CRYPTO_SENDER_PK_CACHE);
            }
        });
    }
    sendRaw(msg, topic) {
        return __awaiter(this, void 0, void 0, function* () {
            if (topic) {
                yield this.sendMsg(topic, msg, constants_1.OKXCONNECTOR_MESSAGE_TTL);
            }
        });
    }
    sendMsg(topic, message, ttl) {
        return __awaiter(this, void 0, void 0, function* () {
            if (message) {
                this.refreshPackageId();
                const payload = {
                    id: this.packageId.toString(),
                    method: commands_1.CONNECT_METHOD_PUBLISH,
                    jsonrpc: constants_1.CONNECT_JSONRPC_VER,
                    params: {
                        message: {
                            topic: topic,
                            message: message,
                            ttl: ttl
                        }
                    } // crypted
                };
                this.events.once(this.packageId.toString(), (rsp) => __awaiter(this, void 0, void 0, function* () {
                    // ack
                    if (rsp && rsp.error) {
                        log.logError(`@${new Date().toUTCString()} >>> failed when send msg`);
                    }
                    else if (rsp && !rsp.error) {
                        log.logDebug(`CONNECTION @[${new Date().toUTCString()}] >>> send msg with id ${this.packageId} successed`);
                    }
                }));
                yield this.connector.send(() => __awaiter(this, void 0, void 0, function* () {
                    log.logDebug('CONNECT: reconnect before send');
                    return yield this.connector.connect();
                }), payload);
            }
        });
    }
    send(topic_1, msg_1) {
        return __awaiter(this, arguments, void 0, function* (topic, msg, needPublicKey = false, ttl = constants_1.OKXCONNECTOR_MESSAGE_TTL, useRaw = false) {
            var _a, _b;
            // make send msg payload
            log.logDebug(`message send =====> ${msg}`);
            if (!this.isTopicPublicKeyExist(topic)) {
                // channel not ready
                throw new Error('connection not finish');
            }
            let connectedDappPK = (_a = this.sessionCryptoInfoMap.get(topic)) === null || _a === void 0 ? void 0 : _a.dappPublicKey;
            let cryptoObject = (_b = this.sessionCryptoInfoMap.get(topic)) === null || _b === void 0 ? void 0 : _b.crypto;
            let messageObj = undefined;
            if (useRaw) {
                messageObj = {
                    message: msg,
                };
            }
            let useCrypto = false;
            if (cryptoObject && connectedDappPK && !useRaw) {
                let message = cryptoObject.encryptWallet(msg, connectedDappPK);
                useCrypto = true;
                messageObj = {
                    message: message,
                };
            }
            if (messageObj) {
                if (needPublicKey && cryptoObject) {
                    messageObj.clientId = (0, utils_1.toHexString)(cryptoObject.keyPair.publicKey);
                    // let privateKey = toHexString(cryptoObject.keyPair.secretKey)
                    // log.logDebug(`message send use dapp publicKey =====> ${connectedDappPK}`)
                    // log.logDebug(`message send use publicKey =====> ${messageObj.clientId}`)
                    // log.logDebug(`message send use secretKey =====> ${privateKey}`)
                }
                let messageStr = (0, safejson_1.safeJsonStringify)(messageObj);
                if (!useRaw && useCrypto) {
                    yield this.splitManager.sendSplitPackages(topic, messageStr, this.sendMsg.bind(this), this.sendRaw.bind(this));
                }
                else {
                    yield this.sendMsg(topic, messageStr, ttl);
                }
            }
        });
    }
    sendACK(msgId_1, success_1) {
        return __awaiter(this, arguments, void 0, function* (msgId, success, reason = undefined) {
            if (success === true) {
                const payload = {
                    id: msgId,
                    jsonrpc: constants_1.CONNECT_JSONRPC_VER,
                    result: true
                };
                yield this.connector.send(() => __awaiter(this, void 0, void 0, function* () {
                    log.logDebug('CONNECT: reconnect before send');
                    return yield this.connector.connect();
                }), payload);
            }
            else if (reason) {
                const payload = {
                    id: msgId,
                    jsonrpc: constants_1.CONNECT_JSONRPC_VER,
                    error: {
                        code: reason.code, //int
                        message: reason.message
                    }
                };
                yield this.connector.send(() => __awaiter(this, void 0, void 0, function* () {
                    log.logDebug('CONNECT: reconnect before send');
                    return yield this.connector.connect();
                }), payload);
            }
        });
    }
    // send receive
    sendReceive(msgId, messageId, topic) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                id: msgId,
                jsonrpc: constants_1.CONNECT_JSONRPC_VER,
                method: commands_1.CONNECT_METHOD_RECEIVE,
                params: {
                    data: {
                        messageId: messageId,
                        topic: topic
                    }
                }
            };
            yield this.connector.send(() => __awaiter(this, void 0, void 0, function* () {
                log.logDebug('CONNECT: reconnect before send');
                return yield this.connector.connect();
            }), payload);
        });
    }
    sendUnsubscribe(topic) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: make disconnect payload
            yield this.connector.send(() => __awaiter(this, void 0, void 0, function* () {
                log.logDebug('CONNECT: reconnect before send');
                return yield this.connector.connect();
            }), {
                id: this.packageId.toString(),
                jsonrpc: constants_1.CONNECT_JSONRPC_VER,
                method: commands_1.CONNECT_METHOD_UNSUB,
                params: {
                    topic: topic
                }
            });
            try {
                yield this.sendDisconnect(topic);
            }
            catch (error) {
                log.logError('send disconnect command failed', error);
            }
            // remove topicId
            this.sessionCryptoInfoMap.delete(topic);
            this.syncCacheSessionInfo();
        });
    }
    // send receive
    // 1. fetch all 
    // 2. send back receive
    // 3. check has more, if so, repeat from 1st step
    sendFetchAndConsumeMessages(msgId, topic) {
        return __awaiter(this, void 0, void 0, function* () {
            //1. send fetch
            this.events.once(msgId, (fetchedMessages) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                //2. consume received messages
                if (fetchedMessages.result) {
                    var hasMore = fetchedMessages.result.hasMore;
                    var receivedMsgs = fetchedMessages.result.data;
                    if (receivedMsgs) {
                        for (let i = 0; i < receivedMsgs.length; i++) {
                            let msg = receivedMsgs[i];
                            if (msg && msg.topic == topic) {
                                let messageId = msg.messageId;
                                yield this.connector.getMsgPayloadFromHistory(msg);
                                // send receive command to relay server
                                this.refreshPackageId();
                                yield this.sendReceive(this.packageId.toString(), messageId, topic);
                            }
                        }
                    }
                    // 3. check hasmore
                    if (hasMore) {
                        this.refreshPackageId();
                        yield this.sendFetchAndConsumeMessages(this.packageId.toString(), topic);
                    }
                }
                else {
                    log.logDebug(`CONNECT: get error rsp ${(_a = fetchedMessages.error) === null || _a === void 0 ? void 0 : _a.code} : ${(_b = fetchedMessages.error) === null || _b === void 0 ? void 0 : _b.message}`);
                }
            }));
            log.logDebug('5. send fetch more');
            const timeFive = new Date().getTime();
            (0, log_1.logDebug)("ConnectTime---5->", timeFive - this.timeLog);
            const payload = {
                id: msgId,
                jsonrpc: constants_1.CONNECT_JSONRPC_VER,
                method: commands_1.CONNECT_METHOD_FETCHMSG,
                params: {
                    data: {
                        topic: topic
                    }
                }
            };
            yield this.connector.send(() => __awaiter(this, void 0, void 0, function* () {
                log.logDebug('CONNECT: reconnect before send');
                return yield this.connector.connect();
            }), payload);
        });
    }
    sendBatchFetchAndConsumeMessages(packageId, topicIdList) {
        return __awaiter(this, void 0, void 0, function* () {
            //1. send fetch
            this.events.once(packageId, (fetchedMessages) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                //2. consume received messages
                if (fetchedMessages.result) {
                    var hasMore = fetchedMessages.result.hasMore;
                    var receivedMsgs = fetchedMessages.result.data;
                    const disconnectedTopics = fetchedMessages.result.disconnectedTopics;
                    if (disconnectedTopics) {
                        try {
                            for (let i = 0; i < disconnectedTopics.length; i++) {
                                const topicInfo = disconnectedTopics[i];
                                if (topicInfo.topic) {
                                    (0, log_1.logDebug)('send receive disconnect:', topicInfo.topic);
                                    yield this.sendRecvDisconnect(topicInfo.topic);
                                    // simulate to make disconnect payload
                                    let disconnectPayload = (0, safejson_1.safeJsonStringify)({
                                        requestId: topicInfo.publishedAt.toString(),
                                        method: commands_1.CONNECT_METHOD_DISCONNECT
                                    });
                                    let disconnectMsg = {
                                        messageId: topicInfo.publishedAt.toString(),
                                        message: (0, safejson_1.safeJsonStringify)({
                                            message: disconnectPayload
                                        }),
                                        topic: topicInfo.topic,
                                        publishedAt: topicInfo.publishedAt
                                    };
                                    yield this.connector.getMsgPayloadFromHistory(disconnectMsg);
                                }
                            }
                        }
                        catch (error) {
                            log.logError('disconnect topic fails', error);
                        }
                    }
                    if (receivedMsgs) {
                        for (let i = 0; i < receivedMsgs.length; i++) {
                            let msg = receivedMsgs[i];
                            if (msg && msg.topic) {
                                // send receive command to relay server
                                let msgPlayloadObject = this.splitManager.tryParseMessageSplitPayload(msg.message);
                                if (msgPlayloadObject) {
                                    yield this.connector.getMsgPayloadFromHistory(msg);
                                }
                                else {
                                    let messageId = msg.messageId;
                                    yield this.connector.getMsgPayloadFromHistory(msg);
                                    this.refreshPackageId(i);
                                    yield this.sendReceive(this.packageId.toString(), messageId, msg.topic);
                                }
                            }
                        }
                    }
                    // 3. check hasmore
                    if (hasMore) {
                        this.refreshPackageId();
                        yield this.sendBatchFetchAndConsumeMessages(this.packageId.toString(), topicIdList);
                    }
                }
                else {
                    log.logDebug(`CONNECT: get error rsp ${(_a = fetchedMessages.error) === null || _a === void 0 ? void 0 : _a.code} : ${(_b = fetchedMessages.error) === null || _b === void 0 ? void 0 : _b.message}`);
                }
            }));
            log.logDebug('5. send fetch more');
            log.reportLog('5. send fetch more');
            const timeFive = new Date().getTime();
            (0, log_1.logDebug)("ConnectTime---5->", timeFive - this.timeLog);
            const payload = {
                id: packageId,
                jsonrpc: constants_1.CONNECT_JSONRPC_VER,
                method: commands_1.CONNECT_METHOD_BATCH_FETCHMSG,
                params: {
                    topics: topicIdList,
                    withInternalData: true
                }
            };
            yield this.connector.send(() => __awaiter(this, void 0, void 0, function* () {
                log.logDebug('CONNECT: reconnect before send');
                yield this.connector.connect();
            }), payload);
        });
    }
    cleanCache() {
        return __awaiter(this, void 0, void 0, function* () {
            this.connectStorage.clearCache();
        });
    }
    saveSessionContent(key, data) {
        if (!data) {
            this.connectStorage.clearCache(storageconstants_1.OKXCONNECTOR_SESSION_PREFIX_KEY + key);
        }
        let jsonData = (0, safejson_1.safeJsonStringify)(data);
        this.connectStorage.encryptStoreMsg(jsonData, storageconstants_1.OKXCONNECTOR_SESSION_PREFIX_KEY + key);
    }
    getSessionContent(key) {
        let jsonStr = this.connectStorage.getAndDecrypt(storageconstants_1.OKXCONNECTOR_SESSION_PREFIX_KEY + key);
        if (jsonStr) {
            let object = (0, safejson_1.safeJsonParse)(jsonStr);
            return object;
        }
        return undefined;
    }
    // subscribe then fetch messages for each topics
    subscribeTopics(topicIdList) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, log_1.logDebug)("4. topicid list", topicIdList);
            log.reportLog("4. topicid list");
            this.refreshPackageId();
            const timeF = new Date().getTime();
            (0, log_1.logDebug)("ConnectTime--subscribe callback->", timeF - this.timeLog);
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                let finishCount = 0;
                //3. send subscribe
                for (let idx = 0; idx < topicIdList.length; ++idx) {
                    let topicId = topicIdList[idx];
                    this.refreshPackageId(idx);
                    this.events.once(this.packageId.toString(), (rsp) => __awaiter(this, void 0, void 0, function* () {
                        // ack
                        if (rsp && rsp.error) {
                            log.logError('failed when subscribe');
                            yield this.connector.disconnect();
                            var error = new Error();
                            error.message = rsp.error.message;
                            error.name = rsp.error.code.toString();
                            // reject(error)
                            finishCount += 1;
                            if (finishCount == topicIdList.length) {
                                resolve();
                            }
                        }
                        this.refreshPackageId(idx);
                        const timeF = new Date().getTime();
                        (0, log_1.logDebug)("ConnectTime--subscribe callback->", timeF - this.timeLog);
                        finishCount += 1;
                        if (finishCount == topicIdList.length) {
                            // 4. fetch messages
                            log.logDebug(`5. send fetch msg: ${this.packageId}, ${topicId}`);
                            yield this.sendBatchFetchAndConsumeMessages(this.packageId.toString(), topicIdList);
                            // 5. split manager resend
                            yield this.splitManager.init(this.sendRaw.bind(this));
                            // 6. check expire or extends expire
                            let checkExpired = this.checkExpire(topicId);
                            if (checkExpired) {
                                (0, log_1.logDebug)('disconnect From topic expire');
                                yield this.activateDisconnect(topicId);
                            }
                            else {
                                (0, log_1.logDebug)('extends expire check');
                                this.updateExpireLimit(topicId);
                            }
                            resolve();
                        }
                    }));
                    log.logDebug(`3. login callback then send subscribe: ${this.packageId}, ${topicId}`);
                    log.reportLog('3. login callback then send subscribe');
                    const timeTh = new Date().getTime();
                    (0, log_1.logDebug)("ConnectTime---login callback->", timeTh - this.timeLog);
                    yield this.connector.send(() => __awaiter(this, void 0, void 0, function* () {
                        log.logDebug('CONNECT: reconnect before send');
                        return yield this.connector.connect();
                    }), {
                        id: this.packageId.toString(),
                        jsonrpc: constants_1.CONNECT_JSONRPC_VER,
                        method: commands_1.CONNECT_METHOD_SUB,
                        params: {
                            topic: topicId
                        }
                    });
                }
            }));
        });
    }
    /**
     * session expire check
     * **/
    checkExpire(topic) {
        let isExpired = false;
        if (topic.length == 0) {
            (0, log_1.logDebug)('checkExpire: invalid topic');
            return isExpired;
        }
        let topicExpireCache = this.getSessionContent(storageconstants_1.OKXCONNECTOR_STORAGE_TOPIC_WALLET_EXPIRE_CACHE);
        if (topicExpireCache && topicExpireCache.get(topic)) {
            let lastTimestamp = topicExpireCache.get(topic);
            if (lastTimestamp) {
                if (Date.now() > lastTimestamp) {
                    (0, log_1.logDebug)('checkExpire: connection is Expired');
                    isExpired = true;
                }
            }
            else {
                (0, log_1.logDebug)('checkExpire: not same connection');
                isExpired = false;
            }
        }
        else {
            (0, log_1.logDebug)('checkExpire: not topic records');
            this.updateExpireLimit(topic);
            isExpired = false;
        }
        return isExpired;
    }
    updateExpireLimit(topic) {
        (0, log_1.logDebug)(`update expire limit for topic: ${topic}`);
        let cacheMap = this.getSessionContent(storageconstants_1.OKXCONNECTOR_STORAGE_TOPIC_WALLET_EXPIRE_CACHE);
        if (!cacheMap) {
            cacheMap = new Map();
        }
        let expireTimestamp = Date.now() + constants_1.OKXCONNECTOR_SESSION_LIVE_TTL; // ttl ms later
        cacheMap.set(topic, expireTimestamp);
        this.saveSessionContent(storageconstants_1.OKXCONNECTOR_STORAGE_TOPIC_WALLET_EXPIRE_CACHE, cacheMap);
    }
    activateDisconnect(topic) {
        return __awaiter(this, void 0, void 0, function* () {
            // simulate to make disconnect payload
            let disconnectPayload = (0, safejson_1.safeJsonStringify)({
                requestId: "",
                method: commands_1.CONNECT_METHOD_DISCONNECT
            });
            let disconnectMsg = {
                messageId: "",
                message: (0, safejson_1.safeJsonStringify)({
                    message: disconnectPayload
                }),
                topic: topic,
                publishedAt: 0
            };
            yield this.connector.getMsgPayloadFromHistory(disconnectMsg);
        });
    }
}
exports.WalletConnectionManager = WalletConnectionManager;
